import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'
import * as tiendasOficialesService from '../../servicios/tiendasOficialesService'
import { buscarPorId } from '../../servicios/usuarioService'
import Error from '../../ui/Error'
import InputEditable from '../../ui/InputEditable'
import ModalBanner from './modals/ModalBanner'
import ModalDescripcionEmpresa from './modals/ModalDescripcionEmpresa'
import ModalLogo from './modals/ModalLogo'

const DatosEmpresa = ({
  tienda,
  setTienda,
  onInsertarTienda,
  onActualizarDescripcion,
  errores,
  setErrores
}) => {
  const [datos, setDatos] = useState([])

  const fetchData = async () => {
    const { data } = await buscarPorId(parseInt(localStorage.getItem('idUsuario')))
    setDatos(data)
  }

  useEffect(() => {
    fetchData()
  }, [])

  const handleChange = (e) => {
    const nombreTienda = e.target.value
    if (nombreTienda === '' || nombreTienda === null) {
      setErrores((prev) => ({
        ...prev,
        inputNombreTienda: 'El nombre de la Tienda no puede quedar vacío'
      }))
    } else {
      setErrores((prev) => {
        const { ...rest } = prev
        return rest
      })
    }
    setTienda((prev) => ({
      ...prev,
      nombreTienda
    }))
  }

  return (
    <div className="row mt-4">
      <div className="col-12 col-md">
        <h3>Empresa</h3>
        <div key={tienda.TEMP_IDUSUARIO} className="ml-2">
          <ul key={tienda.usrId}>
            <li className="li-datos-perfil disabled">
              <span className="float-left">Razón Social</span>&nbsp;
              <span className="float-right">
                {datos.razonSocial || '-\u00A0\u00A0\u00A0'}
              </span>
            </li>
            <li className="li-datos-perfil disabled">
              <span className="float-left">CUIT/CUIL</span>&nbsp;
              <span className="float-right">{datos.cuit}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="col-1"></div>
      <div className="col-12 col-md">
        <h3>Datos de Empresa y Logos</h3>
        <div className="ml-2">
          <ul>
            <Error name="inputNombreTienda" errores={errores}>
              <li className="datos-perfil" id="liDatosPerfil">
                <span className="span-nombre-fantasia">Nombre de Fantasía</span>
                <InputEditable
                  type="text"
                  name="nombreTienda"
                  placeholder="Ingresa el nombre de tu Tienda"
                  onChange={handleChange}
                  texto={tienda.nombreTienda || ''}
                  classInput="input-editable-perfil"
                  classLabel="input-editable-perfil"
                  onClickOutSide={async () => {
                    const tieneError = errores?.inputNombreTienda
                    if (!tieneError) {
                      await tiendasOficialesService.actualizarTienda(tienda)
                    }
                  }}
                />
              </li>
            </Error>

            <Error name="modalLogo" errores={errores}>
              <ModalLogo
                tienda={tienda}
                setTienda={setTienda}
                onInsertarTienda={onInsertarTienda}
              />
            </Error>

            <ModalBanner tienda={tienda} setTienda={setTienda} />

            <ModalDescripcionEmpresa
              tienda={tienda}
              setTienda={setTienda}
              onActualizarDescripcion={onActualizarDescripcion}
              onInsertarTienda={onInsertarTienda}
            />
          </ul>
        </div>
      </div>
    </div>
  )
}

DatosEmpresa.propTypes = {
  tienda: PropTypes.shape({
    TEMP_IDUSUARIO: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    usrId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    nombreTienda: PropTypes.string
  }).isRequired,
  setTienda: PropTypes.func.isRequired,
  onInsertarTienda: PropTypes.func.isRequired,
  onActualizarDescripcion: PropTypes.func.isRequired,
  errores: PropTypes.object,
  setErrores: PropTypes.func.isRequired
}

export default DatosEmpresa
